import * as React from 'react';

import { COLOURS } from '../../../../../consts/style';

export interface IRippleLineProps {
  active: boolean;
}

export const RippleLine = ({ active }: IRippleLineProps) => {
  return (
    <div
      data-id="ripple-line"
      style={{
        backgroundColor: COLOURS.PRIMARY.ORANGE_DARK,
        bottom: 0,
        height: '1px',
        left: 0,
        marginBottom: '24px',
        opacity: active ? 1 : 0,
        position: 'relative',
        top: '-1px',
        transform: active ? `scaleX(1)` : `scaleX(0)`,
        transition:
          'transform 180ms cubic-bezier(0.4, 0, 0.2, 1), opacity 180ms cubic-bezier(0.4, 0, 0.2, 1)',
        width: '241px',
      }}
    />
  );
};
